import { render, staticRenderFns } from "./SelectionChallenge.vue?vue&type=template&id=9b8cf736&scoped=true"
import script from "./SelectionChallenge.vue?vue&type=script&lang=js"
export * from "./SelectionChallenge.vue?vue&type=script&lang=js"
import style0 from "./SelectionChallenge.vue?vue&type=style&index=0&id=9b8cf736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8cf736",
  null
  
)

export default component.exports